(function (_) {
    'use strict';

    _['NOTIFICATIONS_TITLE'] = 'Notificaciones';
    _['NOTIFICATIONS.POPUP.TITLE'] = 'Notificaciones no leídas';
    _['NOTIFICATIONS.POPUP.MSG'] = 'Tienes notificaciones sin leer en el centro de notificaciones.';
    _['NOTIFICATIONS.POPUP.BTN'] = 'Ver notificaciones';
    _['NOTIFICATIONS.NO-NOTIFICATIONS'] = 'No hay notificaciones aún.';
    _['NOTIFICATIONS.NO-PERMISSION'] = 'Has bloqueado tus alertas push.';

}(translations['es']));



// WEBPACK FOOTER //
// ./src/app/modules/notifications/lang/notifications-lang_es.js